var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-center-wrapper"},[_c('VueSkeletonLoader',{staticClass:"skeleton-center",attrs:{"type":"rect","wave-color":"#c5d4e7","color":"#c5d4e7","animation":"fade"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }